import { render, staticRenderFns } from "./PaywaitScreen.vue?vue&type=template&id=c10f5d08&"
import script from "./PaywaitScreen.vue?vue&type=script&lang=js&"
export * from "./PaywaitScreen.vue?vue&type=script&lang=js&"
import style0 from "./PaywaitScreen.vue?vue&type=style&index=0&id=c10f5d08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports